import React, { useCallback, useState } from 'react';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import './Image.scss';

const Image = ({ id, src, alt, style, zoom, className, assetId }) => {
  const getSizeLabel = () => {
    const viewportWidth = window.innerWidth;
    if (viewportWidth < 768) {
      return '_sm';
    }
    if (viewportWidth >= 768 && viewportWidth <= 1024) {
      return '_md';
    }
    if (viewportWidth > 1024) {
      return '';
    }
  };
  let sizedSrc = src;
  if (src.indexOf('.svg') === -1) {
    if (className === 'dynamic-image-item')
      sizedSrc = src.replace(assetId, `${assetId}${getSizeLabel()}`);
    else sizedSrc = src.replace(id, `${id}${getSizeLabel()}`);
  }
  // auto zoom images unless we tell it not to
  let imageZoom = zoom === undefined ? true : zoom;
  const [isZoomed, setIsZoomed] = useState(false);
  const handleImgLoad = useCallback(
    img => {
      var nW = img.naturalWidth;
      if (nW < 450) {
        style.maxWidth = img.style.maxWidth = nW + 'px';
        style.display = img.style.display = 'block';
        style.margin = img.style.margin = 'auto';
        // eslint-disable-next-line
      }
    },
    [style]
  );
  const handleZoomChange = useCallback(shouldZoom => {
    setIsZoomed(shouldZoom);
  }, []);
  return (
    <>
      <div className="visually-hidden" style={{ display: 'none' }}>
        <p>{alt}</p>
      </div>
      {imageZoom ? (
        // quick n dirty image zooming
        <ControlledZoom isZoomed={isZoomed} onZoomChange={handleZoomChange}>
          <img
            id={id}
            onLoad={() => handleImgLoad(document.getElementById(id))}
            alt={alt}
            src={sizedSrc}
            className={className}
            style={{ ...style }}
          />
        </ControlledZoom>
      ) : (
        <img
          id={id}
          className={className}
          style={{ ...style }}
          src={sizedSrc}
          alt={alt}
        />
      )}
    </>
  );
};

export default Image;
